import { Component } from "react";
import { connect } from "react-redux";
import isEqual from "lodash/isEqual";

import { getGrid } from "../../store/slices/grids";
import { fetchGoal, fetchPrecalculation } from "../../store/slices/goal";
import { getBrandSettings } from "../../store/slices/brandsettings";
import { IDashboardConfig, IGoal } from "../../constants/interfaces";
import GoalGrid from "./GoalGrid";
import GoalHeader from "./GoalHeader";
import moment from "moment";

type Props = {
	// injected
	data: IDashboardConfig;
	goal: IGoal;
	dispatch: Function;
	match: {
		params: { id: string };
	};
	brandsettings: any;
};

type State = {
	interval: number | null;
};

class GoalView extends Component<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
			interval: null,
		};
	}

	componentDidMount() {
		const timezone =
			this.props.brandsettings &&
			this.props.brandsettings.domainSettings &&
			this.props.brandsettings.domainSettings.timezone
				? this.props.brandsettings.domainSettings.timezone
				: moment.tz.guess();
		const id = this.props.match.params.id;
		const auth = this.props.dispatch(getBrandSettings());
		let fromTimestamp: string, toTimestamp: string;
		
		auth.then(() => {
			document.body.classList.add(this.props.data?.theme ?? "dark");
			this.props.dispatch(fetchGoal(id)).then(() => {
				const shouldDisplayPrecalcLine = this.props.goal.chartType === "line" && this.props.goal.recurrencyType === "daily" && ["pageviews", "videoPageViews", "conversion", "apppageviews", "webpageviews"].includes(this.props.goal.metricType);
				if (shouldDisplayPrecalcLine) {
					fromTimestamp = moment(
						Math.max(+moment().tz(timezone).startOf("day"), +moment(this.props.goal.iterationStartDate ?? 0))
					).format("HH:mm:00");
					toTimestamp = moment(
						Math.min(
							+moment().tz(timezone).add(1, "day").startOf("day").subtract(15, "minutes"),
							+moment(this.props.goal.iterationEndDate)
						)
					).format("HH:mm:00");
					
					this.props.dispatch(
						fetchPrecalculation(fromTimestamp, toTimestamp, this.props.goal.metricType, this.props.goal.sections ?? [], this.props.goal.conversions ?? [])
					);
				}
			});
			const interval = window.setInterval(() => {
				this.props.dispatch(fetchGoal(id)).then(() => {
					const shouldDisplayPrecalcLine = this.props.goal.chartType === "line" && this.props.goal.recurrencyType === "daily" && ["pageviews", "videoPageViews", "conversion", "apppageviews", "webpageviews"].includes(this.props.goal.metricType);
					if (shouldDisplayPrecalcLine) {
						this.props.dispatch(
							fetchPrecalculation(fromTimestamp, toTimestamp, this.props.goal.metricType, this.props.goal.sections ?? [], this.props.goal.conversions ?? [])
						);
					}
				});
			}, 60000);
			this.setState({ interval });
		});
	}

	componentDidUpdate(prevProps: Props) {
		if (!isEqual(prevProps.data, this.props.data)) {
			this.props.dispatch(getGrid(10));
		}
	}

	componentWillUnmount() {
		if (typeof this.state.interval === "number") {
			window.clearInterval(this.state.interval);
		}
	}

	render() {
		return (
			<div>
				<GoalHeader />
				<GoalGrid recurrencyType={this.props.goal.recurrencyType} />
			</div>
		);
	}
}

const mapStateToProps = (state: any) => {
	return {
		goal: state.goal.data,
		brandsettings: state.brandsettings.data,
	};
};

export default connect(mapStateToProps)(GoalView);
